import { useQuery } from "react-query";
import { getAgencies, getAllManagers } from ".";
import { KEYS_HELPERS } from "./keys";
import { AVATAR_DEFAULT, AVATAR_DEPARTMENT_DEFAULT } from "../../constants";
import { useSearchParams } from "react-router-dom";

export const useQueryGetAllManagers = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const { data, isLoading, isFetching } = useQuery(
        [KEYS_HELPERS.GET_ALL_MANAGERS],
        () => getAllManagers()
    );

    const defaultSelectedManager = [];

    // format data for dropdown
    const format_data = data?.map((manager, index) => {
        const findDefaultManager = searchParams
            .getAll("manager_ids")
            .find((id) => String(id) === String(manager.id));

        if (findDefaultManager) {
            defaultSelectedManager.push({
                header: manager.first_name + " " + manager.last_name,
                content: manager.job_title,
                image: manager.avatar ?? AVATAR_DEFAULT,
                org_data: manager,
            });
        }
        return {
            header: manager.first_name + " " + manager.last_name,
            content: manager.job_title,
            image: manager.avatar ?? AVATAR_DEFAULT,
            org_data: manager,
        };
    });

    return {
        data,
        format_data,
        default_selected_manager: defaultSelectedManager,
        isLoading,
        isFetching,
    };
};

export const useQueryGetAllAgencies = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const { data, isLoading, isFetching } = useQuery(
        [KEYS_HELPERS.GET_ALL_AGENCIES],
        () => getAgencies()
    );

    const defaultSelectedAgencies = [];

    // format data for dropdown
    const format_data = data?.map((agency) => {
        const findDefaultAgency = searchParams
            .getAll("agency_ids")
            .find((id) => String(id) === String(agency.id));

        if (findDefaultAgency) {
            defaultSelectedAgencies.push({
                header: agency.name,
                content: agency.location,
                image: agency.avatar ?? AVATAR_DEPARTMENT_DEFAULT,
                org_data: agency,
            });
        }

        return {
            header: agency.name,
            content: agency.location,
            image: agency.avatar ?? AVATAR_DEPARTMENT_DEFAULT,
            org_data: agency,
        };
    });

    return {
        data,
        format_data,
        default_selected_agency: defaultSelectedAgencies,
        isLoading,
        isFetching,
    };
};
